import React,{useState} from "react";
import { Button, Icon } from "../../components/Component";
import Logo from "../../images/logo12.png";
import LogoDark from "../../images/logo12.png";
import { FormGroup } from "reactstrap";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import { Link,useHistory } from "react-router-dom";
import { authService } from "../../_services/auth";
import {toaster} from "../../_helpers/toaster";
import "./login.css";

const ForgotPassword = () => {

  const [email,setEmail] = useState("");
  const history = useHistory();

  const handleSubmit = (e) =>{
    e.preventDefault();
    
    authService.reset({email}).then(
      result =>{
        // console.log(result);
        toaster.success(result.msg);
        history.push("/auth-reset")
      },
      err =>{
        console.log(err);
        toaster.error(err);        
      }
    )
}

  return (
    <React.Fragment>
      <Head title="Forgot-Password" />
      <PageContainer>
        <main className="login-page forgot-page">
          <section className="login-showcase" aria-label="About MYUAE">
            <div className="login-showcase__glow login-showcase__glow--one" />
            <div className="login-showcase__glow login-showcase__glow--two" />
            <Link to={"/"} className="login-brand login-brand--light" aria-label="MYUAE home">
              <img src={LogoDark} alt="MYUAE" />
            </Link>

            <div className="login-showcase__content">
              <span className="login-eyebrow"><i /> Secure account recovery</span>
              <h1>We’ll help you get back on track.</h1>
              <p>
                Reset your password securely and return to managing your UAE business without missing a step.
              </p>

              <div className="login-benefits">
                <div><span><Icon name="mail" /></span><p><strong>Check your inbox</strong>We’ll send your reset instructions by email.</p></div>
                <div><span><Icon name="shield-check" /></span><p><strong>Safe and private</strong>Your account recovery is securely protected.</p></div>
              </div>
            </div>

            <div className="login-showcase__footer">
              <span className="login-status"><i /> Secure recovery service</span>
              <span>Need help? Our support team is here</span>
            </div>
          </section>

          <section className="login-panel forgot-panel">
            <div className="login-panel__inner">
              <Link to={"/"} className="login-brand login-brand--mobile" aria-label="MYUAE home">
                <img src={Logo} alt="MYUAE" />
              </Link>

              <div className="login-heading">
                <span className="login-heading__icon"><Icon name="lock" /></span>
                <div>
                  <h2>Reset your password</h2>
                  <p>Enter your account email and we’ll send you reset instructions.</p>
                </div>
              </div>

            <form className="is-alter login-form" onSubmit={handleSubmit}>
              <FormGroup className="login-field">
                <div className="form-label-group">
                  <label className="form-label" htmlFor="default-01">
                    Email address
                  </label>
                </div>
                <input
                  type="email"
                  value={email}
                  onChange={(e)=>setEmail(e.target?.value)}
                  className="form-control form-control-lg"
                  id="default-01"
                  placeholder="you@company.com"
                />
              </FormGroup>
              <FormGroup className="login-submit-wrap">
                <Button color="primary" size="lg" className="btn-block login-submit" type="submit">
                  <span>Send reset instructions <Icon name="arrow-right" /></span>
                </Button>
              </FormGroup>
            </form>
            <div className="forgot-return">
              <Link to={`/auth-login`}><Icon name="arrow-left" /> Return to sign in
              </Link>
            </div>

              <div className="login-security"><Icon name="shield-check" /> Secure, encrypted account recovery</div>
            </div>
          </section>
        </main>
        <div className="login-footer"><AuthFooter /></div>
      </PageContainer>
    </React.Fragment>
  );
};
export default ForgotPassword;
